import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { CreateNewState } from '../models/create-new.model';
import * as selectors from '../selectors/create-new.selectors';

@Injectable({ providedIn: 'root' })
export class CreateNewFacadeService extends FacadeService {
  constructor(public override store: Store<CreateNewState>) {
    super(store);
  }

  sidenavStatus$ = this.storeSelect(selectors.getSidenavStatus);
  isEdit$ = this.storeSelect(selectors.getIsEdit);
  editRuleIndex$ = this.storeSelect(selectors.getEditRuleIndex);
  redemptionTypes$ = this.storeSelect(selectors.getRedemptionTypes);
  memberCategories$ = this.storeSelect(selectors.getMemberCategories);
  memberStatuses$ = this.storeSelect(selectors.getMemberStatuses);
  memberTags$ = this.storeSelect(selectors.getMemberTags);
  currencies$ = this.storeSelect(selectors.getCurrencies);
  couponSets$ = this.storeSelect(selectors.getCouponSets);
  bookCouponTemplates$ = this.storeSelect(selectors.getBookCouponTemplates);
  schemaCode$ = this.storeSelect(selectors.getSchemaCode);
  schemaId$ = this.storeSelect(selectors.getSchemaId);
  redemptionType$ = this.storeSelect(selectors.getRedemptionType);
  memberCategoryCode$ = this.storeSelect(selectors.getMemberCategoryCode);
  memberStatusCode$ = this.storeSelect(selectors.getMemberStatusCode);
  memberTagCode$ = this.storeSelect(selectors.getMemberTagCode);
  points$ = this.storeSelect(selectors.getPoints);
  amount$ = this.storeSelect(selectors.getAmount);
  currency$ = this.storeSelect(selectors.getCurrency);
  discount$ = this.storeSelect(selectors.getDiscount);
  couponSetCode$ = this.storeSelect(selectors.getCouponSetCode);
  bookCouponTemplateCode$ = this.storeSelect(selectors.getBookCouponTemplateCode);
  message$ = this.storeSelect(selectors.getMessage);
  submitted$ = this.storeSelect(selectors.getSubmitted);

  get schemaCode() {
    return this.storeSnapshot(this.schemaCode$);
  }

  get schemaId() {
    return this.storeSnapshot(this.schemaId$);
  }

  get isEdit() {
    return this.storeSnapshot(this.isEdit$);
  }

  get editRuleIndex() {
    return this.storeSnapshot(this.editRuleIndex$);
  }

  get redemptionType() {
    return this.storeSnapshot(this.redemptionType$);
  }

  get points() {
    return this.storeSnapshot(this.points$);
  }

  get amount() {
    return this.storeSnapshot(this.amount$);
  }

  get currency() {
    return this.storeSnapshot(this.currency$);
  }

  get discount() {
    return this.storeSnapshot(this.discount$);
  }

  get couponSetCode() {
    return this.storeSnapshot(this.couponSetCode$);
  }

  get bookCouponTemplateCode() {
    return this.storeSnapshot(this.bookCouponTemplateCode$);
  }

  get message() {
    return this.storeSnapshot(this.message$);
  }

  get memberCategoryCode() {
    return this.storeSnapshot(this.memberCategoryCode$);
  }

  get memberStatusCode() {
    return this.storeSnapshot(this.memberStatusCode$);
  }

  get memberTagCode() {
    return this.storeSnapshot(this.memberTagCode$);
  }
}
